const flatbuffers = require('../utils/flatbuffers').flatbuffers;
const Schema = require('./schema_generated').chat.Schema;

const DEFAULT_SIZE = 1024

export const credentialsToByteBuffer = function (companyName, userName, password, type, typeID) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const loginData = Schema.Credentials.createCredentials(builder,
      builder.createString(companyName),
      builder.createString(userName),
      builder.createString(password), type, typeID, true, true)

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.Credentials)
    Schema.Message.addData(builder, loginData)
    Schema.Message.addCmd(builder, Schema.Command.LOGIN)

    const data = Schema.Message.endMessage(builder)
    builder.finish(data)
    return builder.asUint8Array()
}

export const chatToByteBuffer = function (content, author, roomId) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const chatData = Schema.Chat.createChat(builder,0, builder.createString(content), author, roomId)

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.Chat)
    Schema.Message.addData(builder, chatData)
    Schema.Message.addCmd(builder, Schema.Command.CHAT_MESSAGE)

    const data = Schema.Message.endMessage(builder)
    builder.finish(data)
    return builder.asUint8Array()
}

export const listRoomToByteBuffer = function () {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    Schema.Message.startMessage(builder)
    Schema.Message.addCmd(builder, Schema.Command.LIST_ROOM)

    const data = Schema.Message.endMessage(builder)
    builder.finish(data)
    return builder.asUint8Array()
}

export const historyAllChatToByteBuffer = function(listRoomIds) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const roomIdOffset = Schema.HistoryRequest.createRoomIdVector(builder, listRoomIds)
    const historyRequest = Schema.HistoryRequest.createHistoryRequest(builder, builder.createString(""), 200, roomIdOffset)

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.HistoryRequest)
    Schema.Message.addData(builder, historyRequest)
    Schema.Message.addCmd(builder, Schema.Command.HISTORY_CHAT)
    const data = Schema.Message.endMessage(builder)

    builder.finish(data)
    return builder.asUint8Array()
}

export const historyChatInRoomToByteBuffer = function(roomId, pagingStartTime, pagingSize) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const roomIdOffset = Schema.HistoryRequest.createRoomIdVector(builder, [roomId])
    const historyRequest = Schema.HistoryRequest.createHistoryRequest(builder, builder.createString(pagingStartTime), pagingSize, roomIdOffset)

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.HistoryRequest)
    Schema.Message.addData(builder, historyRequest)
    Schema.Message.addCmd(builder, Schema.Command.HISTORY_CHAT)
    const data = Schema.Message.endMessage(builder)

    builder.finish(data)
    return builder.asUint8Array()
}

export const readMessageToByteBuffer = function (roomId, userId, userName) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const dataOffset = Schema.ReadMessage.createReadMessage(builder,roomId, userId, userName)

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.ReadMessage)
    Schema.Message.addData(builder, dataOffset)
    Schema.Message.addCmd(builder, Schema.Command.READ_MESSAGE)

    const data = Schema.Message.endMessage(builder)
    builder.finish(data)
    return builder.asUint8Array()
}

export const incommingMessageToByteBuffer = function (roomId, userId, userName, status) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const dataOffset = Schema.IncommingMessage.createIncommingMessage(builder,roomId, userId,
      builder.createString(userName), status)

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.IncommingMessage)
    Schema.Message.addData(builder, dataOffset)
    Schema.Message.addCmd(builder, Schema.Command.INCOMMING_MESSAGE)

    const data = Schema.Message.endMessage(builder)
    builder.finish(data)
    return builder.asUint8Array()
}

export const appStatusToByteBuffer = function (status) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const dataOffset = Schema.AppStatus.createAppStatus(builder, status)

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.AppStatus)
    Schema.Message.addData(builder, dataOffset)
    Schema.Message.addCmd(builder, Schema.Command.APP_STATUS)

    const data = Schema.Message.endMessage(builder)
    builder.finish(data)
    return builder.asUint8Array()
}

export const appNotificationToByteBuffer = function (phoneType, deviceId, token) {
    const builder = new flatbuffers.Builder(DEFAULT_SIZE)
    const dataOffset = Schema.AppNotification.createAppNotification(builder, phoneType,
      builder.createString(deviceId), builder.createString(token))

    Schema.Message.startMessage(builder)
    Schema.Message.addDataType(builder, Schema.Data.AppNotification)
    Schema.Message.addData(builder, dataOffset)
    Schema.Message.addCmd(builder, Schema.Command.APP_NOTIFICATION)

    const data = Schema.Message.endMessage(builder)
    builder.finish(data)
    return builder.asUint8Array()
}
